var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.595 21.404A1.952 1.952 0 012 20.006c0-.53.217-1.029.595-1.399l14.143-13.5a1.921 1.921 0 012.724.065 1.928 1.928 0 01-.065 2.724L8.742 18.077h27.33c1.068 0 1.928.86 1.928 1.929 0 1.068-.86 1.928-1.929 1.928H8.742l10.663 10.173c.772.74.796 1.953.065 2.724a1.928 1.928 0 01-2.724.065l-14.143-13.5-.008.008z"
  })));
}
export default SvgArrowLeft;